import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { ListHeading, ListSubheading, List, Badge } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';
import { addInitialOperation } from 'store/entities/templates/templates';
import { selectActiveSection } from 'store/entities/templates/selectors';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';

const OperationsList = ({
  isLoading,
  templates,
  entity,
  addInitialOperation,
  activityModel,
  activeSection,
  operationSelected,
  setOperationModalVisible,
  showDeleteOperationsModalUpdated,
  showImportOperationModalUpdated,
  reorderOperationsInSettings,
}) => {
  const { t } = useTranslation();
  const { company: companyId } = useParams();

  return (
    <>
      <ListHeading testId="operations-list-heading" name={t(translations.activityModel_title)} />
      <ListSubheading
        testId="operations-list-subheading"
        item={{
          name: `${t(translations.activityModel_operations)} (${activityModel.length})`,
          actions: [
            {
              label: 'Manage',
              icon: 'add',
              testId: 'operations-list-subheading-more-button',
              subActions: [
                {
                  label: t(translations.add),
                  testId: 'operations-list-subheading-add-button',
                  onClick: () =>
                    addInitialOperation(
                      t(translations.activityModel_newOperation),
                      templates,
                      activeSection,
                      entity,
                      companyId,
                    ),
                  disabled: isLoading,
                },
                {
                  label: t(translations.settings_importFromTemplate),
                  testId: 'operations-list-subheading-import-button',
                  onClick: () => showImportOperationModalUpdated(true),
                  disabled: isLoading,
                },
              ],
            },
          ],
        }}
      />
      <List
        testId="operations-list"
        list={{
          items: activityModel.map((item) => {
            const activityCount = item.activities?.filter((activity) => !activity?.isBranch).length ?? 0;
            const itemTestId = `operations-list-${convertToKebabCase(item.name)}`;
            return {
              id: item.id,
              testId: `${itemTestId}-item`,
              name: item.name,
              active: item.active,
              onClick: () => operationSelected({ operationId: item.id, entity }),
              actions: [
                {
                  childComponent: (
                    <Badge title={String(activityCount)} color={activityCount ? '#cccccc' : ''} textColor={'#ffffff'} />
                  ),
                },
                {
                  label: 'Update',
                  icon: 'edit',
                  testId: `${itemTestId}-update-button`,
                  onClick: () => {
                    operationSelected({ operationId: item.id, entity });
                    setOperationModalVisible(true);
                  },
                },
                {
                  label: 'Delete',
                  icon: 'delete',
                  testId: `${itemTestId}-delete-button`,
                  onClick: () =>
                    showDeleteOperationsModalUpdated({
                      selectedId: item.id,
                      visible: true,
                    }),
                },
              ],
            };
          }),
        }}
        noHeader
        onListReorder={({ from, to }) => {
          if (from === undefined || to === undefined) {
            return;
          }
          reorderOperationsInSettings(
            {
              fromId: activityModel[from]?.id,
              toId: activityModel[to]?.id,
            },
            templates,
            entity,
            companyId,
          );
        }}
        draggable={true}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  const activeSection = selectActiveSection(state);
  return {
    activeSection,
  };
};

const mapDispatchToProps = {
  addInitialOperation,
};

const Container = connect(mapStateToProps, mapDispatchToProps)(OperationsList);

export { Container as OperationsList };
